// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"103":"60a0f425","511":"b22df45d","774":"60a0f425","931":"b22df45d"}[chunkId] + ".chunk.css";
};